// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2DrqT","row":"ProcedureTreatmentSummary_row__24HTB"};